<template>
  <button
    type="button"
    :class='{
      "!border border-gray-100 outline-none text-md px-3 py-2 bg-white hover:!bg-gray-50 transition-colors duration-300 rounded-md shadow-sm disabled:bg-gray-100 flex items-center gap-2": outlined,
      "text-md px-3 py-2 hover:!bg-gray-50 transition-colors duration-300 rounded-md disabled:bg-gray-100 flex items-center gap-2": !outlined
    }'
    @click="setSelectedSort"
  >
    <div>
      <slot></slot>
    </div>
    <div>
      <svg
        v-if="this.selectedSort.name === this.name && !this.selectedSort.descending"
        xmlns="http://www.w3.org/2000/svg"
        class="h-4 w-4"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M5 15l7-7 7 7"
        />
      </svg>
      <svg
        v-if="this.selectedSort.name !== this.name"
        xmlns="http://www.w3.org/2000/svg"
        class="h-4 w-4"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M18 12H6"
        />
      </svg>
      <svg
        v-if="this.selectedSort.name === this.name && this.selectedSort.descending"
        xmlns="http://www.w3.org/2000/svg"
        class="h-4 w-4"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M19 9l-7 7-7-7"
        />
      </svg>
    </div>
  </button>
</template>

<script>
export default {
  props: {
    name: String,
    selectedSort: Object,
    outlined: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    setSelectedSort() {
      if (this.selectedSort.name === this.name) {
        if (this.selectedSort.descending) {
          this.$emit('setSelectedSort', {
            ...this.selectedSort,
            name: '',
          })
        } else {
          this.$emit('setSelectedSort', {
            ...this.selectedSort,
            descending: true,
          })
        }
      } else {
        this.$emit('setSelectedSort', {
          name: this.name,
          descending: false,
        })
      }
    },
  },
}
</script>

<style></style>
